function initForm() {
  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super()

          this.form = this.querySelector('form')
          this.form.querySelector('[name=id]').disabled = false
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        }

        async onSubmitHandler(evt) {
          evt.preventDefault()

          const submitButton = this.form.querySelector('[type="submit"]')
          if (this.isButtonLoading(submitButton)) return

          this.setButtonLoadingState(submitButton, true)

          const formData = this.prepareFormData()

          const extractedFormData = this.extractFormData(formData)

          await this.checkCartItem(extractedFormData)

          this.setButtonLoadingState(submitButton, false)
          window.openCartDrawer()
        }

        isButtonLoading(button) {
          return button.classList.contains('loading')
        }

        setButtonLoadingState(button, isLoading) {
          button.setAttribute('aria-disabled', isLoading)
          button.classList.toggle('loading', isLoading)
          button.innerText = isLoading ? 'Adding...' : 'Add to bag'
        }

        prepareFormData() {
          const formData = new FormData(this.form)
          formData.append('sections_url', window.location.pathname)
          return formData
        }

        extractFormData(formData) {
          const variant_id = formData.get('variant_id')
          const qty = formData.get('quantity')
          const selling_plan = formData.get('selling_plan')
          const product_id = formData.get('id')
          const variants = formData.get('variants')
          const price_varies = Boolean(formData.get('price_varies') === 'true')
          const no_quantity_track = Boolean(formData.get('no_quantity_track') === 'true')

          const propertiesArr = Array.from(formData.entries()).filter(([key, value]) => key.includes('properties'))

          const properties = this.extractProperties(propertiesArr)

          return { variant_id, qty, selling_plan, product_id, variants, price_varies, no_quantity_track, properties }
        }

        extractProperties(propertiesArr) {
          const properties = {}
          const regexGetTextBetweenBrackets = /\[(.*?)\]/
          propertiesArr.forEach(
            ([key, value]) => (properties[key.match(regexGetTextBetweenBrackets)[0]?.trim()] = value)
          )
          return properties
        }

        addToCartCountBubble(qty) {
          const cartCount = document.querySelectorAll('.cart-count')
          if (cartCount) {
            Array.from(cartCount).map((el) => (el.innerText = parseInt(el.innerText) + parseInt(qty)))
          }
        }

        async checkCartItem(extractedFormData) {
          const { variant_id, qty, selling_plan, product_id, price_varies, no_quantity_track, properties } =
            extractedFormData

          const cart = await this.getCartData()
          const variants = await JSON.parse(extractedFormData.variants)

          // Helper function to create itemData object
          const createItemData = (id, quantity, selling_plan, properties) => {
            const itemData = { id, quantity }
            if (selling_plan) itemData.selling_plan = selling_plan
            if (properties) itemData.properties = properties
            return itemData
          }

          // Filter matching items from cart
          const matchingCartItems = Array.from(cart.items).filter((item) => item.product_id == product_id)
          const matchingOneTimeItem = matchingCartItems.find((item) => !item.selling_plan_allocation)
          const matchingSubItem = matchingCartItems.find(
            (item) => item.selling_plan_allocation?.selling_plan?.id == selling_plan
          )

          let itemInCart = (!selling_plan && matchingOneTimeItem) || (selling_plan && matchingSubItem)

          // If product is not in cart or price does not vary or product does not track quantity, add it to the cart
          if (!matchingCartItems.length || !itemInCart || !price_varies || no_quantity_track) {
            const itemData = createItemData(variant_id || variants[0]?.id, qty, selling_plan, properties)
            await this.addCartItem(itemData)
            this.addToCartCountBubble(qty)
            return
          }

          // Item is in the cart already and the price varies based on variant
          const itemToUpdate = selling_plan ? matchingSubItem : matchingOneTimeItem
          const newQuantity = parseInt(itemToUpdate.quantity) + parseInt(qty)

          // Get the new variant based on quantity
          const newQtyVariant = variants.find((v, i) => {
            const lowerBound = parseInt(v.title.split('+')[0])
            const upperBound = parseInt(variants[i + 1]?.title.split('+')[0])
            return upperBound ? lowerBound <= newQuantity && newQuantity < upperBound : lowerBound <= newQuantity
          })

          if (newQtyVariant && itemToUpdate.variant_id != newQtyVariant.id) {
            // Upgrade variant price tier
            // Remove current variant
            await this.removeCartItem(itemToUpdate.key)
            // Add upgraded variant
            const itemData = createItemData(newQtyVariant.id, newQuantity, selling_plan)
            await this.addCartItem(itemData)
          } else {
            // Add item to current price tier
            const itemData = { [itemToUpdate.key]: newQuantity }
            await this.updateCart(itemData)
          }

          this.addToCartCountBubble(qty)
        }

        async getCartData() {
          return await this.fetchAPI('/cart.js', 'GET')
        }

        async addCartItem(item) {
          return await this.fetchAPI('/cart/add.js', 'POST', item)
        }

        async updateCart(updates) {
          return await this.fetchAPI('/cart/update.js', 'POST', { updates })
        }

        async removeCartItem(id) {
          return await this.fetchAPI('/cart/change.js', 'POST', { id, quantity: 0 })
        }

        async fetchAPI(url, method, body) {
          try {
            const res = await fetch(url, {
              method: method,
              headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify(body),
            })
            const data = await res.json()
            return data
          } catch (e) {
            console.log(e)
          }
        }
      }
    )
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initForm()
})
